/**
 * PATH: packages/job-hub/src/jobs/qa/printPdfBytes.ts
 * FILE_ID: JOBHUB-QA-PRINT-PDF-BYTES-001
 * PURPOSE: Print one PDF byte buffer. Phones and Safari use a popup; other desktops use a hidden iframe.
 */

export function needsPrintPopup(desktop: boolean): boolean {
  return !desktop || /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
}

export function printPdfBytes(bytes: Uint8Array, popup?: Window | null): void {
  const copy = new ArrayBuffer(bytes.byteLength)
  new Uint8Array(copy).set(bytes)
  const url = URL.createObjectURL(new Blob([copy], { type: 'application/pdf' }))
  if (popup) {
    popup.location.href = url
    window.setTimeout(() => URL.revokeObjectURL(url), 60_000)
    return
  }
  const iframe = document.createElement('iframe')
  iframe.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;opacity:0;pointer-events:none'
  const cleanup = () => {
    iframe.remove()
    URL.revokeObjectURL(url)
  }
  iframe.onload = () => {
    try {
      iframe.contentWindow?.focus()
      iframe.contentWindow?.print()
      window.setTimeout(cleanup, 60_000)
    } catch {
      cleanup()
    }
  }
  iframe.src = url
  document.body.appendChild(iframe)
}
